import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditCategoryReady} from '../redux/categories'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'



import {EntityStatus} from '../../../common/DropDowns/index'
//import * as Helpers from '../../../common/helpers'

class AddEditCategory extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        categoryDataData:{},

        categoryDataName: "",
        categoryDataGroup: "",
        categoryDataCode: "",
        status: "",

        categoryDataNameErrorText: false,
        categoryDataNameErrorData: '',


        categoryDataCodeErrorText: false,
        categoryDataCodeErrorData: '',

        categoryDataGroupErrorText: false,
        categoryDataGroupErrorData: '',

        statusErrorText: false,
        statusGroupErrorData: '',

        subTitle: Constants.ADD_CATEGORY

    }

    this.isComponentStillMounted = true

    this.categoryDataNameComponent = null
    this.categoryDataNameSection = null

    this.categoryDataGroupComponent = null
    this.categoryDataGroupSection = null

    this.categoryDataCodeComponent = null
    this.categoryDataCodeSection = null

    this.statusCodeComponent = null
    this.statusCodeSection = null

    }

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditCategoryReady(false))

    if (this.props.categories && this.props.categories.categoryDataSelectedId && this.props.categories.categoryDataSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_CATEGORY))
        this.setState({
            subTitle: "Edit Category",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_CATEGORY))
        this.setState({
            subTitle: "Add Category"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    if (this.props.categories && this.props.categories.categoryDataSelectedId && this.props.categories.categoryDataSelectedId !== null) {
        this.getCategoryById(this.props.categories.categoryDataSelectedId)
    }else{

    this.props.dispatch(addEditCategoryReady(true))
    }
}

componentDidMount() {

        this.categoryDataNameSection = ReactDOM.findDOMNode(this.refs.categoryDataNameSection)

        this.categoryDataGroupSection = ReactDOM.findDOMNode(this.refs.categoryDataGroupSection)

        this.categoryDataCodeSection = ReactDOM.findDOMNode(this.refs.categoryDataCodeSection)

        this.statusSection = ReactDOM.findDOMNode(this.refs.statusSection)


}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEditCategoryReady(false))
    let data = {}

    let categoryDataNameObject = this.mandateValidation("categoryDataName", Constants.FORM_INPUT)
    if (categoryDataNameObject.status) {
        data.name = this.categoryDataNameComponent.value
    } else {

         this.props.dispatch(addEditCategoryReady(true))
        return
    }


    let categoryDataCodeObject = this.mandateValidation("categoryDataCode", Constants.FORM_INPUT)
    if (categoryDataCodeObject.status) {
        data.code = this.categoryDataCodeComponent.value
    } else {
        this.props.dispatch(addEditCategoryReady(true))
        return
    }

    let categoryDataGroupObject = this.mandateValidation("categoryDataGroup", Constants.FORM_SELECT)
    if (categoryDataGroupObject.status) {
        data.categoryData_group_id = this.categoryDataGroupComponent.value
    } else {
        this.props.dispatch(addEditCategoryReady(true))
        return
    }

    if(this.state.editFlag){
        let statusObject = this.mandateValidation("status", Constants.FORM_SELECT)
        if (statusObject.status) {
            data.status = this.statusComponent.value
        } else {
            this.props.dispatch(addEditCategoryReady(true))
            return
        }
    }

    let apiPayloadData=data;


    if(this.state.editFlag){

        apiService.editCategory(apiPayloadData,this.state.categoryDataData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditCategoryReady(true))
                        this.props.history.push("/dashboard/categories/list")
                    } else {

                        this.props.dispatch(addEditCategoryReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditCategoryReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addCategory(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditCategoryReady(true))
                        this.props.history.push("/dashboard/categories/list")
                    } else {

                        this.props.dispatch(addEditCategoryReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditCategoryReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getCategoryById = (id) => {
    apiService.getCategoryById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        categoryDataData: responseData.data ,
                        categoryDataName : responseData.data.name,
                        categoryDataCode : responseData.data.code,
                        categoryDataGroup : responseData.data.categoryData_group_id,
                        status : responseData.data.status             
                    })

                    if (this.isComponentStillMounted) {
                        this.categoryDataNameComponent.value=responseData.data.name
                        this.categoryDataCodeComponent.value=responseData.data.code
                        this.categoryDataGroupComponent.value=responseData.data.categoryData_group_id
                        this.statusComponent.value=responseData.data.status
                    }

                    this.props.dispatch(addEditCategoryReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditCategoryReady(true))
        })
}




 categoryDataGroupChange = (data) => {
    this.categoryDataGroupComponent.value=data.value
        this.setState({
            categoryDataGroup :data.value,
            categoryDataGroupErrorText: false,
            categoryDataGroupErrorData: ''
        })
        this.categoryDataGroupSection.className= this.categoryDataGroupSection.className.replace(" has-error", "")
    }





 entityStatusChange= (data) => {
    
        this.statusComponent.value=data.value
    
        this.setState({
            status :data.value,
            statusErrorText: false,
            statusErrorData: ''
        })
            
        this.statusSection.className= this.statusSection.className.replace(" has-error", "")
    }



    







    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.categoryDataNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Category Name" type="text" ref={el => this.categoryDataNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("categoryDataName")}} />
                                                        <span className="help-block"style={{display: this.state.categoryDataNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.categoryDataNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group" ref={el =>
                                                               this.categoryDataCodeSection = el}>
                                                               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Code *</label>
                                                               <div className="col-sm-9">
                                                                  <input className="form-control" placeholder="Enter Category Code" type="text" ref={el => this.categoryDataCodeComponent = el}
                                                                  onChange={(e) => {e.preventDefault() 
                                                                  this.keyedInputChange("categoryDataCode")}} />
                                                                  <span className="help-block" style={{ display: this.state.categoryDataCodeErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                  {this.state.categoryDataCodeErrorData}
                                                                  </span>
                                                               </div>
                                                            </div>
                                                         </div>
                                                    </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                          
                                            </div>

                                             {(() => {
                                        if(this.state.editFlag){
                                            return (

                                             <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.statusSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.statusComponent = el}>
                                                              <EntityStatus type="CATEGORYS" entityStatusChange={this.entityStatusChange} selectedValue={this.state.status} />
                                                              <span className="help-block" style={{ display: this.state.statusErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.statusErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                    </div>                                          
                                                </div>
)
                                        }
                                })()}



                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        categories: state.categories,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditCategory))


// WEBPACK FOOTER //
// ./src/modules/Categories/Components/AddEditCategory.js